import { MainMenuControlCenter } from "./MainMenu.controlcenter";

export const MainMenu: React.FC = () => {
  return  <MainMenuControlCenter />
};
